import ceil from 'lodash/ceil';

export function applyPercentageAdjustment(
  percentage: number,
  amount: number,
): string {
  if (!percentage || percentage === 0) return '0';

  const adjustedNumber = ceil(amount - (amount * percentage) / 100, 2);

  if (Number.isInteger(adjustedNumber)) {
    return adjustedNumber.toFixed(0);
  } else {
    return adjustedNumber.toFixed(2);
  }
}
